export default async function ({ redirect, app, $session, store }) {
  if (process.browser) {
    const { counter, profile } = await store.dispatch('facturacion/facturaStore/facturacionCounter').catch(() => {
      console.error('Error al cargar el counter')

      $session.end()

      return redirect('/')
    })

    console.log('counter', counter)
    console.log('profile', profile)

    $session.setCounter(counter)

    console.log('$session.user.profile', $session.user.profile)
    console.log('$session.user.subProfile', $session.user.subprofile)

    // if (profile === 'COMMUNITY' && counter >= 3) {
    //   if ($session.user.subprofile) return redirect('/accountCounterDisabled')

    //   return redirect('/communityCounter')
    // } else if (profile === 'FACTURA' && counter >= 1520) {
    //   if ($session.user.subprofile) return redirect('/accountCounterDisabled')

    //   return redirect('/1520Counter')
    // } else if (profile === 'MICRO' && counter >= 50) {
    //   if ($session.user.subprofile) return redirect('/accountCounterDisabled')

    //   return redirect('/microCounter')
    // } else if (profile === 'PRO' && counter >= 1520) {
    //   if ($session.user.subprofile) return redirect('/accountCounterDisabled')

    //   return redirect('/1520Counter')
    // }
  }
}
